import * as React from 'react'

// Components
import Svg from './..'

const Times = props => (
  <Svg
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17 0.910714L9.41071 8.5L17 16.0893L16.0893 17L8.5 9.41071L0.910714 17L0 16.0893L7.58929 8.5L0 0.910714L0.910714 0L8.5 7.58929L16.0893 0L17 0.910714Z'
      fill='#06A3F7'
    />
  </Svg>
)

export default Times
